import React from "react";
import { IMAGE_BASE_URL } from "../../common/Constants";

const AgentVoucher = ({ userData }) => {
  return (
    <section className="flooring-full-card-section">
      {userData &&
        userData.map((item, index) => (
          <div className="flooring-full-card" key={index}>
            <div className="full-card-header">
              <div className="logo-block">
                <img
                  src={`${IMAGE_BASE_URL}${item?.agent?.icon}`}
                  alt=""
                />
              </div>
              <div className="card-header-group">
                <div className="card-header-block">
                  <div className="header-block-list">
                    <h2>{item?.agent?.name}</h2>
                    <div className="inline-flex">
                      {item?.agent?.hasPremium ? (
                        <span className="category-list">
                          <img
                            src="/images/prem_icon.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Premium</span>
                        </span>
                      ) : null}
                      {item?.agent?.featured ? (
                        <span className="category-list">
                          <img
                            src="/images/star.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Featured</span>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="header-block-list">
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_clock.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Approval time:
                      <strong className="ml-[5px] font-[600]">
                        {item?.agent?.approvalTime}
                      </strong>
                    </p>
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_zap.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Loan to Value:
                      <strong className="ml-[5px] font-[600]">
                        {item?.agent?.ltv}
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="card-header-info">
                  <div className="info-header-block-list">
                    <h3 className="info-view-col">
                      Interest Rate (per 30 days)
                      <span>
                        {item?.agent?.product?.interest_from.slice(
                          0,
                          item?.agent?.product?.interest_from.indexOf(".") + 2
                        )}
                        % -{" "}
                        {item?.agent?.product?.interest_to.slice(
                          0,
                          item?.agent?.product?.interest_to.indexOf(".") + 2
                        )}
                        %
                      </span>{" "}
                    </h3>
                    <h4 className="info-view-col">
                      Admin Fee{" "}
                      <span>
                        ${item?.agent?.product?.admin_fee_from.slice(
                          0,
                          item?.agent?.product?.admin_fee_from.indexOf(".")
                        )} - $
                        {item?.agent?.product?.admin_fee_to.slice(
                          0,
                          item?.agent?.product?.admin_fee_to.indexOf(".")
                        )}
                      </span>
                    </h4>
                  </div>{" "}
                </div>
              </div>
            </div>
            {item?.agent?.vouchers?.name !== undefined && (
              <div className="selected-voucher">
                <p>Voucher Selected:</p>
              </div>
            )}
            {item?.agent?.vouchers?.name !== undefined && (
              <div className="eligible-voucher-section">
                <div className="eligible-voucher-block">
                  <div className="eligible-circle-left" />
                  <div className="eligible-voucher-list">
                    <h2>
                      Interest Rate{" "}
                      <span>
                        {" "}
                        {item?.agent?.vouchers.interest_rate.slice(
                          0,
                          item?.agent?.vouchers?.interest_rate.indexOf(".") + 2
                        )}
                      </span>
                    </h2>
                    <h2>
                      <span>{item?.agent?.vouchers?.customer_type?.label}</span>
                      {item?.agent?.vouchers?.voucher_qty_type?.value == 0 ? (
                        <span>{item?.agent?.vouchers?.voucher_qty_type?.label}</span>
                      ) : (
                        <span>
                          {item?.agent?.vouchers?.redeemed_qty}/{item?.agent?.vouchers?.qty} voucher(s)
                          left
                        </span>
                      )}
                    </h2>
                    <h3>
                      Valid From <span>{item?.agent?.vouchers?.start_period} - {item?.agent?.vouchers?.end_period}</span>
                    </h3>
                    <h3>
                      Eligible Floor Amount
                      <span>
                        $
                        {item?.agent?.vouchers.amount_from.slice(
                          0,
                          item?.agent?.vouchers.amount_from.indexOf(".")
                        )}{" "}
                        - ${item?.agent?.vouchers?.amount_to.slice(0, item?.agent?.vouchers.amount_to.indexOf("."))}
                      </span>                    </h3>
                    <h4>
                      You Redeemed
                      <span>
                        {item?.agent?.vouchers.dealer_redeemed_qty}/
                        {item?.agent?.vouchers?.max_redemption} times
                      </span>
                    </h4>
                  </div>
                  <div className="eligible-circle-right" />
                </div>
              </div>
            )}
          </div>
        ))}
    </section>
  );
};

export default AgentVoucher;
